import script from "./PageView.vue?vue&type=script&setup=true&lang=js"
export * from "./PageView.vue?vue&type=script&setup=true&lang=js"

import "./PageView.vue?vue&type=style&index=0&id=0194d28f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0194d28f"]])

export default __exports__